import { keepPreviousData, useQueryClient } from "@tanstack/react-query";

import { useFetchQuery, useFetchMutation } from "common/queries/hooks";
import { WithStringValues } from "common/utils/types";
import { IPaginatedQuery } from "common/types";

import { keys as orderKeys } from "client/orders/hooks/constants";

import { urls, keys } from "./constants";
import {
  ReviewsSearch,
  IListClientReview,
  IClientReviewCreateMutation,
  IClientCreateReview,
  IClinicReview,
} from "../types";

export const useClinicReviewsQuery = (search: WithStringValues<ReviewsSearch>) => {
  return useFetchQuery<IPaginatedQuery<IClinicReview>, WithStringValues<ReviewsSearch>>(
    keys.clinicReviewList(search),
    {
      fetch: { url: urls.clinicReviews(), body: search },
      config: { placeholderData: keepPreviousData },
    },
  );
};

export const useClientReviewCreateMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const queryClient = useQueryClient();
  return useFetchMutation<IClientReviewCreateMutation, IClientCreateReview>({
    fetch: (body) => ({ method: "POST", url: urls.createClientReview(), body }),
    config: {
      onSuccess,
      onSettled: () => {
        queryClient.invalidateQueries({ queryKey: keys.clientReviews() });
        queryClient.invalidateQueries({ queryKey: orderKeys.all() });
      },
    },
  });
};

export const useClientReviewsQuery = (search: WithStringValues<ReviewsSearch>) => {
  return useFetchQuery<IPaginatedQuery<IListClientReview>, WithStringValues<ReviewsSearch>>(
    keys.clientReviewList(search),
    {
      fetch: { url: urls.clientReviews(), body: search },
    },
  );
};
